/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddTaskExcuseCommand } from '../../models/add-task-excuse-command';
import { AddTaskExcuseCommandResult } from '../../models/add-task-excuse-command-result';

export interface ApiTaskAddTaskExcusePut$Params {
      body?: AddTaskExcuseCommand
}

export function apiTaskAddTaskExcusePut(http: HttpClient, rootUrl: string, params?: ApiTaskAddTaskExcusePut$Params, context?: HttpContext): Observable<StrictHttpResponse<AddTaskExcuseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskAddTaskExcusePut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddTaskExcuseCommandResult>;
    })
  );
}

apiTaskAddTaskExcusePut.PATH = '/api/Task/AddTaskExcuse';
